import Layout from "../Layout"
import Spinner from "./VideoShare/Spinner"

const Loading = () => (
  <Layout>
    <div
      css={{
        borderRadius: 8,
        background: "rgba(0, 0, 0, 0.20)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        color: "gray",
        fontSize: 16,
        borderRadius: 8,
        width: 320,
        height: 600,
        gap: 24,
      }}
    >
      <Spinner />
      Loading...
    </div>
  </Layout>
)

export default Loading
